import React from 'react';
import { Award, CheckCircle, Users, Star } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { trustSignals } from '../mock';

export const TrustSection = () => {
  return (
    <section id="trust" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-[#3E2723] mb-4">
            Trusted by Businesses Nationwide
          </h2>
          <p className="text-lg text-[#8D6E63] max-w-3xl mx-auto">
            Our track record speaks for itself. Join hundreds of satisfied clients who have successfully protected their brands with our expert trademark services.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {trustSignals.map((signal, index) => (
            <Card
              key={index}
              className="border-2 border-[#D7CCC8] hover:border-[#8D6E63] transition-all duration-300 hover:shadow-lg bg-[#EFEBE9]"
            >
              <CardContent className="p-8 text-center">
                <div className="text-5xl font-bold text-[#3E2723] mb-2">
                  {signal.metric}
                </div>
                <div className="text-[#8D6E63] font-medium">
                  {signal.label}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <Card className="border-2 border-[#D7CCC8] bg-white">
            <CardContent className="p-6 text-center">
              <div className="w-14 h-14 bg-[#3E2723] rounded-full flex items-center justify-center mx-auto mb-4">
                <Award className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-lg font-bold text-[#3E2723] mb-2">
                USPTO Registered
              </h3>
              <p className="text-sm text-[#8D6E63]">
                Officially recognized by the United States Patent and Trademark Office
              </p>
            </CardContent>
          </Card>

          <Card className="border-2 border-[#D7CCC8] bg-white">
            <CardContent className="p-6 text-center">
              <div className="w-14 h-14 bg-[#3E2723] rounded-full flex items-center justify-center mx-auto mb-4">
                <CheckCircle className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-lg font-bold text-[#3E2723] mb-2">
                Guaranteed Quality
              </h3>
              <p className="text-sm text-[#8D6E63]">
                Meticulous attention to detail ensures accurate applications
              </p>
            </CardContent>
          </Card>

          <Card className="border-2 border-[#D7CCC8] bg-white">
            <CardContent className="p-6 text-center">
              <div className="w-14 h-14 bg-[#3E2723] rounded-full flex items-center justify-center mx-auto mb-4">
                <Users className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-lg font-bold text-[#3E2723] mb-2">
                Expert Team
              </h3>
              <p className="text-sm text-[#8D6E63]">
                Experienced trademark professionals dedicated to your success
              </p>
            </CardContent>
          </Card>

          <Card className="border-2 border-[#D7CCC8] bg-white">
            <CardContent className="p-6 text-center">
              <div className="w-14 h-14 bg-[#3E2723] rounded-full flex items-center justify-center mx-auto mb-4">
                <Star className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-lg font-bold text-[#3E2723] mb-2">
                Client Satisfaction
              </h3>
              <p className="text-sm text-[#8D6E63]">
                500+ happy clients with 5-star reviews and testimonials
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};
